import { useEffect, useState } from "react";

export default function StudentEnrollments() {
  const [enrollments, setEnrollments] = useState([]);
  const [students, setStudents] = useState([]);

  const [programs, setPrograms] = useState([]);
  const [semesters, setSemesters] = useState([]);
  const [subjects, setSubjects] = useState([]);

  const [filteredSemesters, setFilteredSemesters] = useState([]);
  const [filteredSubjects, setFilteredSubjects] = useState([]);

  const [formData, setFormData] = useState({
    student_id: "",
    program: "",
    semester: "",
    subject: "",
  });

  const [editId, setEditId] = useState(null);
  const apiUrl = "http://localhost:8081/api/admin/student-enrollments";

  useEffect(() => {
    // Main enrollments data
    fetch(apiUrl)
      .then(res => res.json())
      .then(data => setEnrollments(data));

    fetch("http://localhost:8081/api/admin/students")
      .then(res => res.json())
      .then(data => {
         setStudents(data);
         console.log(data);
         
      });

    fetch("http://localhost:8081/api/admin/programs")
      .then(res => res.json())
      .then(data => setPrograms(data));

    fetch("http://localhost:8081/api/admin/semesters")
      .then(res => res.json())
      .then(data => setSemesters(data));

    fetch("http://localhost:8081/api/admin/subjects")
      .then(res => res.json())
      .then(data => setSubjects(data));
  }, []);

  useEffect(() => {
    if (formData.program) {
      const filtered = semesters.filter(s => s.program_id === parseInt(formData.program));
      setFilteredSemesters(filtered);
      setFilteredSubjects([]); // reset subjects
      setFormData(prev => ({ ...prev, semester: "", subject: "" }));
    }
  }, [formData.program, semesters]);

  useEffect(() => {
    if (formData.semester) {
      const filtered = subjects.filter(sub => sub.semester_id === parseInt(formData.semester));
      setFilteredSubjects(filtered);
      setFormData(prev => ({ ...prev, subject: "" }));
    }
  }, [formData.semester, subjects]);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const method = editId ? "PUT" : "POST";
    const url = editId ? `${apiUrl}/${editId}` : apiUrl;

    try {
      fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    })
      .then(() => fetch(apiUrl))
      .then(res => res.json())
      .then(data => {
        setEnrollments(data);
        setFormData({ student_id: "", program: "", semester: "", subject: "" });
        setEditId(null);
      }).catch(err => {
        console.log(err);
        
      });
    } catch (error) {
      alert("Something went wrong!");
    }
  };

  const handleDelete = (id) => {
    fetch(`${apiUrl}/${id}`, { method: "DELETE" })
      .then(() => fetch(apiUrl))
      .then(res => res.json())
      .then(data => setEnrollments(data));
  };

  const handleEdit = (item) => {
    setFormData({
      student_id: item.student_id,
      program: item.program,
      semester: item.semester,
      subject: item.subject,
    });
    setEditId(item.id);
  };

  return (
    <div className="enrollment-container">
      <h2>Student Subject Enrollments</h2>

      <form onSubmit={handleSubmit}>
        <select name="student_id" value={formData.student_id} onChange={handleChange} required>
          <option value="">Select Student</option>
          {students.map((s) => (
            <option key={s.user_id} value={s.user_id}>{s.full_name}</option>
          ))}
        </select>

        <select name="program" value={formData.program} onChange={handleChange} required>
          <option value="">Select Program</option>
          {programs.map((p) => (
            <option key={p.id} value={p.id}>{p.name}</option>
          ))}
        </select>

        <select name="semester" value={formData.semester} onChange={handleChange} required>
          <option value="">Select Semester</option>
          {filteredSemesters.map((s) => (
            <option key={s.semester_id} value={s.semester_id}>{s.name}</option>
          ))}
        </select>

        <select name="subject" value={formData.subject} onChange={handleChange} required>
          <option value="">Select Subject</option>
          {filteredSubjects.map((sub) => (
            <option key={sub.id} value={sub.id}>{sub.name}</option>
          ))}
        </select>

        <button type="submit">{editId ? "Update" : "Add"} Enrollment</button>
      </form>

      <ul>
        {enrollments.map((enroll) => (
          <li key={enroll.id}>
            {enroll.student_id} - {enroll.program} - {enroll.semester} - {enroll.subject}
            <button onClick={() => handleEdit(enroll)}>Edit</button>
            <button onClick={() => handleDelete(enroll.id)}>Delete</button>
          </li>
        ))}
      </ul>
    </div>
  );
}
